import { useCallback } from 'react'

import { setSettingData, setSettings } from 'slices/account-lookup-slice'
import { useSelector } from 'react-redux'
import { useAppDispatch } from 'store'
import { RootState } from 'slices'

export const useIxMainFilterType = (accountType: any , forceMainFilterType: any, name: any) => {

    const dispatch = useAppDispatch()
    const { settings } = useSelector((state: RootState) => state.accountLookupSlice)

    const onMainFilterType = useCallback((e: any) => {
        const number = Number(e.element.id)

        if (number === 0) {
            forceMainFilterType !== null
                ? dispatch(setSettings({forceMainFilterType: {...settings.forceMainFilterType, [name]: {...settings.forceMainFilterType[name],[`${accountType}`]: 0}}}))
                : dispatch(setSettingData({typeSetting: 'mainFilterType', settingNumber: accountType, value: 0}))
        }
        else if (forceMainFilterType !== null ? (settings.forceMainFilterType[name][`${accountType}`] & number) > 0 : (settings.mainFilterType[`${accountType}`] & number) > 0) {
            forceMainFilterType !== null
                ? dispatch(setSettings({forceMainFilterType: {...settings.forceMainFilterType, [name]: {...settings.forceMainFilterType[name], [`${accountType}`]: settings.forceMainFilterType[name][`${accountType}`] & (~number)}}}))
                : dispatch(setSettingData({typeSetting: 'mainFilterType', value: settings.mainFilterType[`${accountType}`] & (~number), settingNumber: accountType}))
        }
        else {
            forceMainFilterType !== null
                ? dispatch(setSettings({forceMainFilterType: {...settings.forceMainFilterType, [name]: {...settings.forceMainFilterType[name], [`${accountType}`]: settings.forceMainFilterType[name][`${accountType}`] | number}}}))
                : dispatch(setSettingData({typeSetting: 'mainFilterType', settingNumber: accountType,  value: settings.mainFilterType[`${accountType}`] | number}))
        }

    },[dispatch, settings, forceMainFilterType, accountType, name])

    return  [
        forceMainFilterType !== null ? settings.forceMainFilterType[name][`${accountType}`] : settings.mainFilterType[`${accountType}`],
        onMainFilterType as any
    ]
}
